import { ReactElement } from 'react';

import { AppointmentDetails, AppointmentDetailsQuery } from '@dreryk/egabinet-appointment-frontend-api';
import { AppointmentId } from '@dreryk/egabinet-appointment-published-language-api';
import { PatientSimple, PatientSimpleQuery } from '@dreryk/egabinet-patient-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import { commonTranslationKeys } from '@dreryk/react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

type WaitlistEntryConfirmReservationModalLoaderRenderProps = {
   appointmentDetails: AppointmentDetails;
   patient: PatientSimple;
};

type WaitlistEntryConfirmReservationModalLoaderProps = {
   appointmentId: AppointmentId | undefined;
   children: (renderProps: WaitlistEntryConfirmReservationModalLoaderRenderProps) => ReactElement;
   patientId: number;
};

export const WaitlistEntryConfirmReservationModalLoader = (
   props: WaitlistEntryConfirmReservationModalLoaderProps
): ReactElement | null => {
   const { data: patient, loading: patientLoading, error: patientError } = useCqrsGet<PatientSimple>(() => {
      const query = new PatientSimpleQuery();
      query.id = Slot.of(props.patientId);
      return query;
   });

   const {
      data: appointmentDetails,
      loading: appointmentDetailsLoading,
      error: appointmentDetailsError,
   } = useCqrsGet<AppointmentDetails>(
      () => {
         const query = new AppointmentDetailsQuery();
         if (props.appointmentId) {
            query.appointmentId = props.appointmentId;
         }
         return query;
      },
      { enabled: Boolean(props.appointmentId) }
   );

   if (patientLoading || appointmentDetailsLoading) {
      return <LoaderSpinner />;
   }

   if (patientError || appointmentDetailsError) {
      return (
         <Message
            testId={'confirmReservationFetchError'}
            type={MessageType.NEGATIVE}
            label={commonTranslationKeys.unexpectedErrorHasOccurred}
            displayIndicator
         />
      );
   }

   return props.children({
      appointmentDetails: appointmentDetails,
      patient: patient,
   });
};
